import { useEffect, useRef } from 'react';
import { useOrders } from '@contexts/OrdersContext';
import { useStore } from '@contexts/StoreContext';
import { useSound } from '@contexts/SoundContext';

const OrderSoundNotifier: React.FC = () => {
  const { data } = useOrders();
  const { restaurantId } = useStore();
  const { playOrderBlip } = useSound();

  const previousIdsRef = useRef<Set<string>>(new Set());
  const isFirstSnapshotRef = useRef(true);
  const restaurantRef = useRef<number | null>(restaurantId);

  useEffect(() => {
    if (restaurantRef.current !== restaurantId) {
      restaurantRef.current = restaurantId;
      previousIdsRef.current = new Set();
      isFirstSnapshotRef.current = true;
    }

    if (!data) return;

    const currentIds = new Set(
      data.map(o => (o.deliveryId as string) || '').filter(id => id !== '')
    );

    if (!isFirstSnapshotRef.current) {
      const hasNew = Array.from(currentIds).some(
        id => !previousIdsRef.current.has(id)
      );
      if (hasNew) {
        playOrderBlip();
      }
    }

    previousIdsRef.current = currentIds;
    isFirstSnapshotRef.current = false;
  }, [data, restaurantId, playOrderBlip]);

  return null;
};

export default OrderSoundNotifier;
